module.exports = __webpack_public_path__ + "img/product-1-50.png?84459bda246ebe6d32a59e1d29f83d30";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/product-1-50.png
// module id = 420
// module chunks = 0